import React from 'react';

import { useOverlayState } from '../../../../hooks/useOverlayState';

import {
    STAGE_TYPE,
    STAGE_STATUS,
    ORDERED_STATUSES,
    CONTENT_DETAIL_KEY,
    SUBMIT_BUTTON_LABEL,
} from '../../../../constants/cycleDetail';

import StageProgress from '../StageProgress/StageProgress';
import FeedbackSection from '../FeedbackSection/FeedbackSection';
import StageInstructions from '../StageInstructions/StageInstructions';
import ReviewQuestionnaireModal from '../ReviewQuestionnaireModal/ReviewQuestionnaireModal';
import { Badge, Button } from '../../../../design-system';

const CycleSidePanel = ({ cycleData, submitStatusUpdate, actionsLoading }) => {
    const { current_stage } = cycleData;
    const { name, type, progress, stage_status, default_version } = current_stage || {};
    const { status_key, status_label, status_color, instructions } = stage_status || {};
    const details = default_version?.details || {};

    const { isOpened: isModalOpened, open: openModal, close: closeModal } = useOverlayState();

    const submitState = actionsLoading === 'statusChange' ? 'loading' : 'default';

    const withViewQuestionnaireButton =
        [STAGE_TYPE.clear_picture, STAGE_TYPE.realistic_design].includes(type) &&
        [STAGE_STATUS.in_progress, STAGE_STATUS.in_review].includes(status_key);

    const withSubmitFormButton = CONTENT_DETAIL_KEY[type]?.[status_key];
    const submitButtonLabel = SUBMIT_BUTTON_LABEL[type]?.[status_key] || 'Submit';

    const withButtons = withSubmitFormButton || withViewQuestionnaireButton;

    const handleSubmit = async () => {
        const currentStatusIndex = ORDERED_STATUSES.indexOf(status_key);
        const nextStatus = ORDERED_STATUSES[currentStatusIndex + 1] || STAGE_STATUS.success;

        await submitStatusUpdate({ status: nextStatus });
    };

    return (
        <div className="w-[312px] min-w-[312px] min-[1800px]:w-[360px] min-[1800px]:min-w-[360px] px-8 pt-5 pb-8 flex flex-col gap-5 bg-neutral-50 h-full overflow-y-auto">
            <div className="flex flex-col gap-5 pb-5 border-b-1 border-neutral-200">
                {withButtons && (
                    <div className="flex flex-col gap-5">
                        {withSubmitFormButton && (
                            <Button
                                type="primary"
                                size="xs"
                                text={submitButtonLabel}
                                state={submitState}
                                onClick={handleSubmit}
                            />
                        )}

                        {withViewQuestionnaireButton && (
                            <Button
                                type="ghost"
                                size="xs"
                                text="View Questionnaire"
                                onClick={openModal}
                            />
                        )}
                    </div>
                )}

                <StageInstructions instructions={instructions} />
            </div>

            <div className="flex flex-col gap-2 pb-5 border-b-1 border-neutral-200">
                <StageProgress name={name} progress={progress} gapY={8} gapX={24} />

                <div className="flex flex-col gap-1 items-start">
                    <p className="font-body text-body-regular-xs text-neutral-300">Status</p>

                    <Badge text={status_label} color={status_color} />
                </div>
            </div>

            {status_key === STAGE_STATUS.in_review && <FeedbackSection />}

            {isModalOpened && (
                <ReviewQuestionnaireModal type={type} details={details} onClose={closeModal} />
            )}
        </div>
    );
};

export default CycleSidePanel;
